import { useThemeProps, DevNotice } from "../../wsui/base";

import DefaultTextModule from "./DefaultTextModule.jsx";
import ExpandableTextModule from "./ExpandableTextModule.jsx";

function defaultComponentMapping({ expandable }) {
  if (expandable) return ExpandableTextModule;
  return DefaultTextModule;
}

export default function TextModuleController(props) {
  props = useThemeProps({
    props,
    name: "MunicipioTextModuleController",
  });

  let { componentMapping, ...restProps } = props;

  const Component =
    typeof componentMapping === "function"
      ? componentMapping(restProps, defaultComponentMapping)
      : defaultComponentMapping(restProps);

  if (!Component) {
    return (
      <DevNotice>{`Text module could not be mapped to a component`}</DevNotice>
    );
  }

  return <Component {...restProps} />;
}
